<div class="department-list-options">
  <div class="department-list-title-container">
    <p class="department-list-subtitle">{{ 'departmentListTab.subTitle' | translate }}</p>
    <p>{{ 'departmentListTab.refreshInfo' | translate }}</p>
  </div>
</div>

<div class="department-list-container" *ngIf="hasDepartments()" #departmentListContainer>
  <div class="department-list">
    <cdk-virtual-scroll-viewport #virtualDepartmentList class="scroll-viewport" [itemSize]="70">
      <div class="department-list-header" [ngStyle]="{ 'top': inverseOfTranslation }">
        <div class="header-cell department-header"
             [ngStyle]="{'width': departmentNameColumnWidth}"
             [ngClass]="{'scroll-separator': hasScrollSeparator }">
          <div class="column-header-title" (click)="toggleSorting()">
            <span>{{ 'departmentListTab.headers.name' | translate }}</span>
            <svg-icon class="header-icon sort-direction"
                      [ngClass]="{'rotated': !isAsc}"
                      icon="sorting">
            </svg-icon>
          </div>
        </div>
        <div class="scroll-helper"
             [ngStyle]="{'transform': scrollHelperTransform}"
             visibilityObserver
             (visibilityChange)="onVisibilityChanged($event)"
             [intersectionRoot]="departmentListContainer">
        </div>
        <div *ngFor="let serviceColumn of serviceColumns" class="header-cell" [ngStyle]="{'min-width': serviceColumn.baseWidth}" [ngClass]="{'header-cell-omni':isOmniService(serviceColumn.serviceType)}">
          <div class="outer-column-header-title" [ngStyle]="{'left': headerStickyOffset}">
            <svg-icon class="header-icon" icon="{{ getIconByService(serviceColumn.workItemType) }}"></svg-icon>
            <span>{{ serviceColumn.title | translate }}</span>
          </div>
          <div class="inner-column-header-titles">
            <div class="inner-column-header-title status">{{ 'departmentListTab.headers.agentStatus' | translate }}</div>
            <div class="separator" *ngIf="hasBot(serviceColumn)"></div>
            <div class="inner-column-header-title bot" *ngIf="hasBot(serviceColumn)">
              <div class="title-text">{{ 'departmentListTab.headers.bot' | translate }}</div>
              <div *ngIf="isOmniService(serviceColumn.serviceType)" class="omni-header">
                <div *ngFor="let service of servicesWithBotIncludedInOmni" class="included-channel">
                  <div class="separator"></div>
                  <div class="channel">
                    <svg-icon class="header-icon" icon="{{ getIconByService(service.workItemType) }}"></svg-icon>
                    <ng2-tooltip direction="top" text="{{ getTooltip(service.workItemType) | translate }}"></ng2-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator"></div>
            <div class="inner-column-header-title queue">
              <div class="title-text">{{ 'departmentListTab.headers.queue' | translate }}</div>
              <div *ngIf="isOmniService(serviceColumn.serviceType)" class="omni-header">
                <div *ngFor="let includedService of omniIncludedServices" class="included-channel">
                  <div class="separator"></div>
                  <div class="channel">
                    <svg-icon class="header-icon" icon="{{ getIconByService(includedService.workItemType) }}"></svg-icon>
                    <ng2-tooltip direction="top" text="{{ getTooltip(includedService.workItemType) | translate }}"></ng2-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator"></div>
            <div class="inner-column-header-title assigned">
              <div class="title-text">{{ 'departmentListTab.headers.assigned' | translate }}</div>
              <div *ngIf="isOmniService(serviceColumn.serviceType)" class="omni-header">
                <div *ngFor="let includedService of omniIncludedServices" class="included-channel">
                  <div class="separator"></div>
                  <div class="channel">
                    <svg-icon class="header-icon" icon="{{ getIconByService(includedService.workItemType) }}"></svg-icon>
                    <ng2-tooltip direction="top" text="{{ getTooltip(includedService.workItemType) | translate }}"></ng2-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-row" *ngIf="hasMoreThanOneDepartment()">
        <div class="list-cell department-name-column"
             [ngClass]="{'scroll-separator': hasScrollSeparator}"
             [ngStyle]="{'width': departmentNameColumnWidth}">
          <div class="summary-info">
            <div class="summary-title">{{ 'departmentListTab.summary' | translate }}</div>
            <div  class="agents-total-count" *ngIf="summary.agentsCount !== undefined">
              {{ getAgentCountsText(summary.signedInAgentsCount) | translate:{ active: summary.signedInAgentsCount, total: summary.agentsCount } }}
            </div>
            <app-skeleton-loader *ngIf="summary.agentsCount === undefined" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
          </div>
        </div>
        <div *ngFor="let serviceColumn of serviceColumns" class="list-cell" [ngStyle]="{'min-width': serviceColumn.baseWidth}" [ngClass]="{'list-cell-omni':isOmniService(serviceColumn.serviceType)}">
          <div class="divided-cell">
            <div class="inner-cell status" [ngClass]="{'clickable': isClickableStatus(getTotalStatusCount(serviceColumn))}" (click)="onStatusDrilldown(serviceColumn)">
              <div *ngIf="getTotalStatusCount(serviceColumn); let totalStatusCount">
                <div class="status-indicator available">
                  <svg-icon icon="dot" class="dot"></svg-icon>
                  <span>{{ totalStatusCount[statusTypes.AVAILABLE] || 0 }} {{ 'departmentListTab.available' | translate }}</span>
                </div>
                <div class="status-indicator away">
                  <svg-icon icon="dot" class="dot"></svg-icon>
                  <span>{{ totalStatusCount[statusTypes.AWAY] || 0 }} {{ 'departmentListTab.away' | translate }}</span>
                </div>
              </div>
              <app-skeleton-loader *ngIf="!getTotalStatusCount(serviceColumn)" [subItemCount]="1" [mainItemCount]="1"></app-skeleton-loader>
            </div>
            <div class="separator" *ngIf="hasBot(serviceColumn)"></div>
            <div class="inner-cell bot" *ngIf="hasBot(serviceColumn)">
              <div class="summary-bot-assigned-count">
                <span *ngIf="getTotalAssignedCount(serviceColumn); let assignedCount">{{ assignedCount.bot }}</span>
                <app-skeleton-loader *ngIf="!getTotalAssignedCount(serviceColumn)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
              </div>
              <ng-container *ngIf="isOmniService(serviceColumn.serviceType)">
                <div class="separator"></div>
                <div class="included-channels">
                  <div *ngFor="let service of servicesWithBotIncludedInOmni" class="included-channel">
                    <div class="channel">
                      <span *ngIf="getTotalAssignedCount(service); let assignedCount">{{ assignedCount.bot }}</span>
                      <app-skeleton-loader *ngIf="!getTotalAssignedCount(service)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
                    </div>
                    <div class="separator"></div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="separator"></div>
            <div class="inner-cell queue" [ngClass]="{'clickable': !isOmniService(serviceColumn.serviceType) && (summary.queueCounts && isClickableCount(summary.queueCounts[serviceColumn.serviceType]))}" (click)="onQueueDrilldown(serviceColumn)">
              <div class="queue-count">
                <div class="summary-queue-count" *ngIf="getTotalQueueCount(serviceColumn) !== null">{{ summary.queueCounts[serviceColumn.serviceType] }}</div>
                <div class="longest-waiting" *ngIf="getMaxLongestWaitingByService(serviceColumn)">
                  <span>{{ 'departmentListTab.longestWaiting' | translate }}: </span><br>
                  <span>{{ getMaxLongestWaitingByService(serviceColumn) }}</span>
                </div>
                <app-skeleton-loader *ngIf="getTotalQueueCount(serviceColumn) === null" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
              </div>
              <ng-container *ngIf="isOmniService(serviceColumn.serviceType)">
                <div class="included-channels">
                  <div *ngFor="let includedService of omniIncludedServices" class="included-channel">
                    <div class="separator"></div>
                    <div class="channel" [ngClass]="{'clickable': (summary.queueCounts && isClickableCount(summary.queueCounts[includedService.serviceType]))}" (click)="onQueueDrilldown(includedService)">
                      <div>{{ getTotalQueueCount(includedService) }}</div>
                      <app-skeleton-loader *ngIf="getTotalQueueCount(includedService) === null" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="separator"></div>
            <div class="inner-cell assigned" [ngClass]="{'clickable': !isOmniService(serviceColumn.serviceType) && (summary.assignedCounts && isClickableCount(summary.assignedCounts[serviceColumn.serviceType]?.assigned))}" (click)="onAssignedDrilldown(serviceColumn)">
              <div class="assigned-count">
                <span class="summary-assigned-count" *ngIf="getTotalAssignedCount(serviceColumn); let assignedCount">{{ assignedCount.assigned }}</span>
                <app-skeleton-loader *ngIf="!getTotalAssignedCount(serviceColumn)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
              </div>

              <ng-container *ngIf="isOmniService(serviceColumn.serviceType)">
                <div class="separator"></div>
                <div class="included-channels">
                  <div *ngFor="let includedService of omniIncludedServices" class="included-channel">
                    <div class="channel" [ngClass]="{'clickable': (summary.assignedCounts && isClickableCount(summary.assignedCounts[includedService.serviceType]?.assigned))}" (click)="onAssignedDrilldown(includedService)">
                      <span *ngIf="getTotalAssignedCount(includedService); let assignedCount">{{ assignedCount.assigned }}</span>
                      <app-skeleton-loader *ngIf="!getTotalAssignedCount(includedService)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
                    </div>
                    <div class="separator"></div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="department-list-row" *cdkVirtualFor="let department of displayedDepartmentList">
        <div class="list-cell department-name-column"
             [ngClass]="{'scroll-separator': hasScrollSeparator }"
             [ngStyle]="{'width': departmentNameColumnWidth}">
          <div class="department-info">
            <div class="name" title="{{ department.name }}">{{ department.name }}</div>
            <div class="department-size" *ngIf="department.agentsCount !== undefined">
              {{ getAgentCountsText(department.signedInAgentsCount) | translate:{ active: department.signedInAgentsCount, total: department.agentsCount } }}
            </div>
            <app-skeleton-loader *ngIf="department.agentsCount === undefined" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
          </div>
        </div>
        <div *ngFor="let serviceColumn of serviceColumns" class="list-cell" [ngStyle]="{'min-width': serviceColumn.baseWidth}" [ngClass]="{'list-cell-omni':isOmniService(serviceColumn.serviceType)}">
          <div class="divided-cell">
            <div class="inner-cell status" [ngClass]="{'clickable': isClickableStatus(getStatusCount(department, serviceColumn))}" (click)="onStatusDrilldown(serviceColumn, department)">
              <div *ngIf="getStatusCount(department, serviceColumn); let statusCount">
                <div class="status-indicator available">
                  <svg-icon icon="dot" class="dot"></svg-icon>
                  <span>{{ statusCount[statusTypes.AVAILABLE] || 0 }} {{ 'departmentListTab.available' | translate }}</span>
                </div>
                <div class="status-indicator away">
                  <svg-icon icon="dot" class="dot"></svg-icon>
                  <span>{{ statusCount[statusTypes.AWAY] || 0 }} {{ 'departmentListTab.away' | translate }}</span>
                </div>
              </div>
              <app-skeleton-loader *ngIf="!getStatusCount(department, serviceColumn)" [subItemCount]="1" [mainItemCount]="1"></app-skeleton-loader>
            </div>
            <div class="separator" *ngIf="hasBot(serviceColumn)"></div>
            <div class="inner-cell bot" *ngIf="hasBot(serviceColumn)">
              <div class="bot-assigned-count">
                <span *ngIf="getAssignedCount(department, serviceColumn); let assignedCount">{{ assignedCount.bot }}</span>
                <app-skeleton-loader *ngIf="!getAssignedCount(department, serviceColumn)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
              </div>

              <ng-container *ngIf="isOmniService(serviceColumn.serviceType)">
                <div class="separator"></div>
                <div class="included-channels">
                  <div *ngFor="let serviceWithBot of servicesWithBotIncludedInOmni" class="included-channel">
                    <div class="channel">
                      <span *ngIf="getAssignedCount(department, serviceWithBot); let assignedCount">{{ assignedCount.bot }}</span>
                      <app-skeleton-loader *ngIf="!getAssignedCount(department, serviceWithBot)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
                    </div>
                    <div class="separator"></div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="separator"></div>
            <div class="inner-cell queue" [ngClass]="{'clickable': !isOmniService(serviceColumn.serviceType) && isClickableCount(getQueueCount(department, serviceColumn))}" (click)="onQueueDrilldown(serviceColumn, department)">
              <div *ngIf="getQueueCount(department, serviceColumn) !== null" class="queue-count">
                <div class="count">{{ getQueueCount(department, serviceColumn) }}</div>
                <div *ngIf="getLongestWaiting(department, serviceColumn)" class="longest-waiting" [ngClass]="{'max-longest-waiting-time': isMaxLongestWaitingTime(department, serviceColumn)}">
                  <span>{{ 'departmentListTab.longestWaiting' | translate }}: </span><br>
                  <svg-icon *ngIf="isOmniService(serviceColumn.serviceType)" icon="{{ getLongestWaitingIconForOmni(department) }}" class="longest-waiting-icon"></svg-icon>
                  <span>{{ getLongestWaiting(department, serviceColumn) | appElapsed }}</span>
                </div>
              </div>
              <app-skeleton-loader class="queue-count" *ngIf="getQueueCount(department, serviceColumn) === null" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>

              <ng-container *ngIf="isOmniService(serviceColumn.serviceType)">
                <div class="included-channels">
                  <div *ngFor="let includedService of omniIncludedServices" class="included-channel">
                    <div class="separator"></div>
                    <div class="channel" [ngClass]="{'clickable':isClickableCount(getQueueCount(department, includedService))}" (click)="onQueueDrilldown(includedService, department)">
                      <div>{{ getQueueCount(department, includedService) }}</div>
                      <app-skeleton-loader *ngIf="getQueueCount(department, includedService) === null" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="separator"></div>
            <div class="inner-cell assigned" [ngClass]="{'clickable': !isOmniService(serviceColumn.serviceType) && isClickableCount(getAssignedCount(department, serviceColumn)?.assigned)}" (click)="onAssignedDrilldown(serviceColumn, department)">
              <div class="assigned-count">
                <span *ngIf="getAssignedCount(department, serviceColumn); let assignedCount">{{ assignedCount.assigned }}</span>
                <app-skeleton-loader *ngIf="!getAssignedCount(department, serviceColumn)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
              </div>

              <ng-container *ngIf="isOmniService(serviceColumn.serviceType)">
                <div class="separator"></div>
                <div class="included-channels">
                 <div *ngFor="let includedService of omniIncludedServices" class="included-channel">
                   <div class="channel" [ngClass]="{'clickable': isClickableCount(getAssignedCount(department, includedService)?.assigned)}" (click)="onAssignedDrilldown(includedService, department)">
                     <span *ngIf="getAssignedCount(department, includedService); let assignedCount">{{ assignedCount.assigned }}</span>
                     <app-skeleton-loader *ngIf="!getAssignedCount(department, includedService)" [subItemCount]="1" [mainItemCount]="0"></app-skeleton-loader>
                   </div>
                   <div class="separator"></div>
                 </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>

<div *ngIf="!hasDepartments()" class="empty-state">
  <svg-icon icon="no-departments"></svg-icon>
  <div class="no-departments-title">{{ 'departmentListTab.emptyState.noDepartmentsTitle'| translate}}</div>
  <div class="no-departments-subtitle">{{ 'departmentListTab.emptyState.noDepartmentsSubtitle'| translate}}</div>
</div>
